import { render } from "./complete-page.vue?vue&type=template&id=4dc1b62b&scoped=true&ts=true"
import script from "./complete-page.ts?vue&type=script&lang=ts&external"
export * from "./complete-page.ts?vue&type=script&lang=ts&external"

import "./complete-page.less?vue&type=style&index=0&id=4dc1b62b&lang=less&scoped=true&external"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc1b62b"]])

export default __exports__